export const FETCH_CURRENT_BUCKET_MEMBERS_REQUEST =
    '@@buckets/FETCH_CURRENT_BUCKET_MEMBERS_REQUEST';
export const FETCH_BUCKET_MEMBERS_REQUEST =
    '@@buckets/FETCH_BUCKET_MEMBERS_REQUEST';
export const FETCH_BUCKET_MEMBERS_SUCCESS =
    '@@buckets/FETCH_BUCKET_MEMBERS_SUCCESS';
export const FETCH_BUCKET_MEMBERS_FAILURE =
    '@@buckets/FETCH_BUCKET_MEMBERS_FAILURE';

export const TOGGLE_ADD_MEMBER = '@@buckets/TOGGLE_ADD_MEMBER';
export const ADD_BUCKET_MEMBERS_REQUEST =
    '@@buckets/ADD_BUCKET_MEMBERS_REQUEST';
export const ADD_BUCKET_MEMBERS_SUCCESS =
    '@@buckets/ADD_BUCKET_MEMBERS_SUCCESS';
export const ADD_BUCKET_MEMBERS_FAILURE =
    '@@buckets/ADD_BUCKET_MEMBERS_FAILURE';

/* User actions in bucket */
export const CHANGE_USERS_ROLE_REQUEST = '@@buckets/CHANGE_USERS_ROLE_REQUEST';
export const CHANGE_USERS_ROLE_SUCCESS = '@@buckets/CHANGE_USERS_ROLE_SUCCESS';
export const CHANGE_USERS_ROLE_FAILURE = '@@buckets/CHANGE_USERS_ROLE_FAILURE';
export const REMOVE_USERS_REQUEST = '@@buckets/REMOVE_USERS_REQUEST';
export const REMOVE_USERS_SUCCESS = '@@buckets/REMOVE_USERS_SUCCESS';
export const REMOVE_USERS_FAILURE = '@@buckets/REMOVE_USERS_FAILURE';
export const CURRENT_USER_ROLE_CHANGE_SUCCESS =
    '@@buckets/CURRENT_USER_ROLE_CHANGE_SUCCESS';

export const ADD_USERS_TO_BUCKETS_REQUEST =
    '@@buckets/ADD_USERS_TO_BUCKETS_REQUEST';
export const ADD_USERS_TO_BUCKETS_SUCCESS =
    '@@buckets/ADD_USERS_TO_BUCKETS_SUCCESS';
export const ADD_USERS_TO_BUCKETS_FAILURE =
    '@@buckets/ADD_USERS_TO_BUCKETS_FAILURE';

export const UPDATE_BUCKET_REQUEST = '@@buckets/UPDATE_BUCKET_REQUEST';
export const UPDATE_BUCKET_SUCCESS = '@@buckets/UPDATE_BUCKET_SUCCESS';
export const UPDATE_BUCKET_FAILURE = '@@buckets/UPDATE_BUCKET_FAILURE';

export const CHANGE_BUCKET_SETTINGS_NAME =
    '@@buckets/CHANGE_BUCKET_SETTINGS_NAME';
export const CHANGE_BUCKET_SETTINGS_APPLICATION_IDS =
    '@@buckets/CHANGE_BUCKET_SETTINGS_APPLICATION_IDS';
export const UPDATE_BUCKET_SETTINGS_REQUEST =
    '@@buckets/UPDATE_BUCKET_SETTINGS_REQUEST';
export const UPDATE_BUCKET_SETTINGS_SUCCESS =
    '@@buckets/UPDATE_BUCKET_SETTINGS_SUCCESS';
export const UPDATE_BUCKET_SETTINGS_FAILURE =
    '@@buckets/UPDATE_BUCKET_SETTINGS_FAILURE';
export const RESET_BUCKET_SETTINGS = '@@buckets/RESET_BUCKET_SETTINGS';

export const UPDATE_BUCKET_AVATAR_REQUEST =
    '@@buckets/UPDATE_BUCKET_AVATAR_REQUEST';
export const UPDATE_BUCKET_AVATAR_SUCCESS =
    '@@buckets/UPDATE_BUCKET_AVATAR_SUCCESS';
export const UPDATE_BUCKET_AVATAR_FAILURE =
    '@@buckets/UPDATE_BUCKET_AVATAR_FAILURE';

/* User filter */
export const CHANGE_BUCKET_MEMBERS_FILTER =
    '@@/buckets/CHANGE_BUCKET_MEMBERS_FILTER';



// WEBPACK FOOTER //
// ./src/constants/buckets.js